import { render, staticRenderFns } from "./HomeNavigation.vue?vue&type=template&id=f2663686&scoped=true&"
import script from "./HomeNavigation.vue?vue&type=script&lang=js&"
export * from "./HomeNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2663686",
  null
  
)

export default component.exports